<template>
  <Container :enabled-keyword="false">
    <div class="card p-3 px-4">
      <form @submit.prevent="_refetchData">
        <div class="row">
          <div class="col-md-3">
            <div class="form-group" ref="perusahaan">
              <label for="" class="form-label">Pilih Perusahaan</label>
              <selectize
                v-model="filter.id_perusahaan"
                data-placeholder="Pilih Perusahaan"
                :disabled="loading"
                @input="_getDriver"
              >
                <option :value="perusahaan.id" v-for="(perusahaan, index) in perusahaan" :key="index">
                  {{ perusahaan.nama_perusahaan }}
                </option>
              </selectize>
            </div>
          </div>

          <div class="col-md-3">
            <div class="form-group" ref="sales">
              <label for="" class="form-label">Pilih Driver</label>
              <selectize
                v-model="filter.id_driver"
                data-placeholder="Pilih Driver"
                required
                :disabled="loading"
              >
                <option :value="d.id" v-for="(d, i) in driver" :key="i">
                  {{ d.nama_driver }}
                </option>
              </selectize>
            </div>
          </div>

          <div class="col-md-3">
            <div class="form-group">
              <label for="" class="form-label">Tanggal</label>
              <input
                type="date"
                class="form-control"
                required
                v-model="filter.date"
                ref="date"
              />
            </div>
          </div>
          <div class="col-auto form-group">
            <label for="" class="form-label">&nbsp;</label>
            <button
              type="submit"
              :disabled="loading"
              class="btn btn-primary"
              v-html="ic('search') + ' Fetch Data'"
            />
          </div>
        </div>
      </form>
    </div>
    <div class="alert alert-info" v-if="!requested">
      <i class="fe fe-info mr-2"></i>
      Select a filter and click "Fetch Data" to load the data
    </div>
    <div
      class="alert alert-info d-flex justify-content-between align-items-center"
      v-if="checkeds.length > 0"
    >
      <div class="col-auto">
        Total Nominal :
        <span class="font-weight-bold">{{ "Rp " + ribuan(totalNominal) }}</span>
      </div>
      <div>
        <button class="btn btn-danger mr-3" @click="_rejectChecked">
          Reject
        </button>
        <button class="btn btn-info" @click="_approveChecked">Approve</button>
      </div>
    </div>
    <DataTable
      :skeleton="loading"
      :noData="!loading && data.length === 0 && requested"
      :show="!loading && data.length > 0"
      :filter="filter"
      :action="_refetchData"
      :pagination="false"
    >
      <thead>
        <tr>
          <th v-for="(header, i) in headers" :key="i">{{ header }}</th>
          <th class="pos-relative">
            <label
              class="form-check"
              style="position: absolute; top: 4px; right: 10px"
            >
              <input
                class="form-check-input"
                type="checkbox"
                :checked="data.length === checkeds.length"
                @click="_checkUncheck"
              />
              <span class="form-check-label"></span>
            </label>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, i) in data" :key="i">
          <td nowrap class="click-able text-primary" @click="_edit(row)">
            {{ row.no_invoice }} <br />
            {{ row.id_penjualan }} <br />
            <span
              v-html="row.tipe_pembayaran"
              class="badge"
              :class="
                row.tipe_pembayaran === 'cash' ? 'bg-danger' : 'bg-primary'
              "
            />
          </td>
          <td>
            {{ row.nama_toko }} <br />
            {{ row.no_acc }} <br />
            {{ row.cust_no }}
          </td>
          <td>
            {{ dFormat(row.tanggal, "dMY") }}
          </td>
          <td>
            {{ row.nama_salesman }} <br />
            {{ row.nama_tim }}
          </td>
          <td style="text-transform: capitalize">
            {{ clearCase(row.tipe) }} <br />
            {{ row.bank }} <br />
          </td>
          <td style="white-space: nowrap">
            <span class="pull-right">{{ "Rp " + ribuan(row.nominal) }}</span>
            <template
              v-for="(desc, j) in ['keterangan', 'no_bg', 'jatuh_tempo_bg']"
            >
              <br v-if="row[desc] !== '' && row[desc] != null" :key="j" />
              <span
                class="pull-right"
                style="text-transform: capitalize"
                v-html="row[desc]"
              />
            </template>
          </td>
          <td>
            <span v-html="dateFormat(row.created_at).split(' ').join('<br>')" />
            <br />
            {{ row.created_name }}
          </td>
          <td>
            <span
              v-html="row.status"
              class="badge w-100"
              :class="
                row.status == 'waiting'
                  ? 'bg-warning'
                  : row.status == 'rejected'
                  ? 'bg-danger'
                  : 'bg-success'
              "
            />
          </td>
          <td class="text-right pos-relative">
            <label
              class="form-check"
              style="
                position: absolute;
                top: 50%;
                transform: translate(0, -50%);
                right: 10px;
              "
            >
              <input
                class="form-check-input"
                type="checkbox"
                :value="row.id"
                v-model="checkeds"
              />
              <span class="form-check-label"></span>
            </label>
          </td>
        </tr>
      </tbody>
    </DataTable>

    <FormPelunasanDriver
        :config.sync="modals.form.config"
        :initData="modals.form.data"
        :isSubmit.sync="modals.form.isSubmit"
        @submit="modals.form.action"
    />
  </Container>
</template>
<script>
import helper from "@/assets/js/helper.js";
import FormPelunasanDriver from "./modals/form-pelunasan-driver.vue";
import { mapActions } from "vuex";

export default {
  name: "PelunasanDriver",
  components: {FormPelunasanDriver},
  mixins: [helper],
  data() {
    return {
      headers: [
        "No",
        "Toko",
        "Tanggal Pelunasan",
        "Salesman",
        "Pembayaran",
        "",
        "Diinput Pada",
        "status",
      ],
      filter: {
        id_perusahaan: "",
        id_driver: "",
        date: helper.methods.dateTime("ymd"),
      },
      checkeds: [],
      data: [],
      loading: false,
      driver: [],
      perusahaan: [],
      requested: false,
      modals:{
        form:{
          config: {
            view: false,
            title: ""
          },
          data: null,
          action: () => {},
        }
      }
    };
  },
  computed: {
    totalNominal() {
      // Filter the data for checked rows and sum their nominal values
      return this.checkeds.reduce((sum, checkedId) => {
        const row = this.data.find((item) => item.id === checkedId);
        return sum + (row ? row.nominal : 0);
      }, 0);
    },
  },
  methods: {
    ...mapActions("perusahaan", ["getListPerusahaanByAccess"]),
    ...mapActions("driver", ["getListDriver","getDriverOptimize"]),
    ...mapActions("depo", ["getListDepo"]),

    async _getPerusahaan() {
      this.perusahaan = await this.getListPerusahaanByAccess();
    },

    async _getDriver() {
      let ids_perusahaan = this.filter.id_perusahaan;
      if (ids_perusahaan.length === 0) {
        ids_perusahaan = this.perusahaan.map((item) => item.id);
      }else{
        ids_perusahaan = ids_perusahaan;
      }
      this.getListDepo({ id_perusahaan: ids_perusahaan }).then(async (res) => {
        const ids_depo = res.map(item => item.id);
        this.driver = await this.getListDriver(ids_depo);
      });
    },
    
    _checkUncheck() {
      if (this.checkeds.length !== this.data.length) {
        this.checkeds = [];
        for (let i = 0; i < this.data.length; i++) {
          let item = this.data[i];
          this.checkeds.push(item.id);
        }
      } else {
        this.checkeds = [];
      }
    },
    _approveChecked() {
      this.checkeds.forEach(async (id) => {
        this.axios
          .post(`detail_pelunasan_penjualan/approve/${id}`)
          .then(() => {
            this.toast("Berhasil disetujui");
          })
          .catch((err) => {
            this.onError(err);
            this.toast("Gagal disetujui");
          })
          .finally(() => {
            this._refetchData();
            this.checkeds = [];
          });
      });
    },
    _rejectChecked() {
      this.checkeds.forEach(async (id) => {
        this.axios
          .post(`detail_pelunasan_penjualan/reject/${id}`)
          .then(() => {
            this.toast("Berhasil dibatalkan");
          })
          .catch((err) => {
            this.onError(err);
            this.toast("Gagal dibatalkan");
          })
          .finally(() => {
            this._refetchData();
            this.checkeds = [];
          });
      });
    },
    _refetchData() {
      this.requested = true;
      this.loading = true;
      this.axios
        .get("detail_pelunasan_penjualan", {
          params: {
            id_perusahaan: this.filter.id_perusahaan,
            id_driver: this.filter.id_driver,
            start_date: this.filter.date,
            end_date: this.filter.date,
            tipe_pembayaran: "cash",
            per_page: "all",
            page: "1",
            id_mitra: "include",
            status: "waiting",
          },
        })
        .then((res) => {
          this.loading = false;
          this.data = res.data.data;
        })
        .catch((err) => {
          this.loading = false;
          this.onError(err);
        });
    },
    _edit(detail_pelunasan){
      this.modals.form.config = {
        view: true,
        title: "Edit Pelunasan Canvass"
      }
      this.modals.form.data = detail_pelunasan
      this.modals.form.action = (updateRequest) => {
        this.axios.put(`detail_pelunasan_penjualan/${detail_pelunasan.id}`, updateRequest).then(res => {
          this.toast('Berhasil diupdate')
          this._refetchData()
          this.modals.form.config.view = false
        }).catch(err => {
          this.onError(err)
          this.modals.form.isSubmit = false;
        })        
      }
    }

  },
  mounted() {
    this._getDriver();
    this._getPerusahaan();
  },
  created() {},
};
</script>
